export default __webpack_public_path__ + "images/96720771be7b0235673ae95c5607fcf1.svg";